import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83494aaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-10 flex justify-center" }
const _hoisted_2 = { class: "flex items-stretch mb-10 z-20" }
const _hoisted_3 = { class: "m-2 flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_NFTGrid = _resolveComponent("NFTGrid")!
  const _component_ArrowButton = _resolveComponent("ArrowButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, {
      active: _ctx.isLoading,
      "is-full-page": _ctx.fullPage,
      loader: _ctx.loader
    }, null, 8, ["active", "is-full-page", "loader"]),
    _createElementVNode("div", _hoisted_1, [
      (
        (_ctx.toWalletNFTs && _ctx.toWalletNFTs.length) ||
        (_ctx.toVaultNFTs && _ctx.toVaultNFTs.length)
      )
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "bg-rb-mickeyred text-white rounded-lg py-2 px-3 mx-2",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.moveNFTsOnChain && _ctx.moveNFTsOnChain(...args)))
          }, " Move NFTs! "))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NFTGrid, {
        title: "Your Wallet",
        class: "flex-1 p-2 border border-red-900 bg-gray-50 rounded-xl shadow-lg",
        nfts: _ctx.desiredWalletNFTs,
        onSelected: _ctx.handleWalletSelected
      }, null, 8, ["nfts", "onSelected"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ArrowButton, {
          class: "my-2 mx-auto w-5",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moveNFTsFE(false)))
        }),
        _createVNode(_component_ArrowButton, {
          class: "my-2 mx-auto w-5",
          left: true,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moveNFTsFE(true)))
        })
      ]),
      (_ctx.bank && _ctx.vault)
        ? (_openBlock(), _createBlock(_component_NFTGrid, {
            key: 0,
            title: "Your Staking Vault",
            class: "flex-1 p-2 border border-red-900 bg-gray-50 rounded-xl shadow-lg z-20",
            nfts: _ctx.desiredVaultNFTs,
            onSelected: _ctx.handleVaultSelected
          }, null, 8, ["nfts", "onSelected"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}